import { QuestionText } from "./QuestionText";

interface AnswerOptionProps {
  letter: string;
  text: string;
  state: "idle" | "selected" | "correct" | "wrong";
  onClick?: (() => void) | undefined;
  disabled?: boolean | undefined;
}

/**
 * Correct/wrong are carried by an icon and a label as well as colour.
 *
 * Roughly 1 in 12 Nigerian men is red-green colourblind, and this is the one
 * component in the product where colour alone would decide whether a student
 * thinks they got it right.
 */
const styles: Record<AnswerOptionProps["state"], string> = {
  idle: "border-border bg-surface",
  selected: "border-accent bg-accent-tint",
  correct: "border-positive bg-[var(--positive-tint)]",
  wrong: "border-negative bg-[rgba(228,87,79,0.12)]",
};

export function AnswerOption({ letter, text, state, onClick, disabled }: AnswerOptionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={state !== "idle"}
      className={`flex min-h-12 w-full items-center gap-3 rounded-[var(--radius-control)] border px-3.5 py-3 text-left text-[14.5px] leading-[1.4] ${styles[state]}`}
    >
      <span className="tabular grid h-6 w-6 shrink-0 place-items-center rounded-full border border-border-strong text-[12px] font-semibold">
        {letter}
      </span>
      <QuestionText className="flex-1">{text}</QuestionText>
      {state === "correct" ? (
        <span className="shrink-0 text-[12px] font-semibold text-positive">✓ Correct</span>
      ) : state === "wrong" ? (
        <span className="shrink-0 text-[12px] font-semibold text-negative">✗ Not this one</span>
      ) : null}
    </button>
  );
}
